import type { ReactNode } from 'react';
import './BottomNavigation.css';

export interface TabDefinition {
  id: string;
  label: string;
  icon: ReactNode;
  /** Счётчик на бейдже (например, число неоплаченных заказов). */
  badge?: number;
}

interface BottomNavigationProps {
  tabs: TabDefinition[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

/**
 * Нижняя навигация. Своя, а не Tabbar из telegram-ui: нужен бейдж, управление
 * фокусом и точный контроль safe-area, которые проще держать в одном месте.
 * Цвета берутся из CSS-переменных темы Telegram, поэтому вид совпадает с
 * нативным и автоматически следует за светлой/тёмной темой.
 */
export function BottomNavigation({ tabs, activeIndex, onSelect }: BottomNavigationProps) {
  return (
    <nav className="bottom-nav" role="tablist" aria-label="Основная навигация">
      {tabs.map((tab, index) => {
        const isActive = index === activeIndex;

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`tab-${tab.id}`}
            aria-selected={isActive}
            aria-controls={`panel-${tab.id}`}
            className={`bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`}
            onClick={() => onSelect(index)}
          >
            <span className="bottom-nav__icon">
              {tab.icon}
              {tab.badge ? <span className="bottom-nav__badge">{tab.badge > 99 ? '99+' : tab.badge}</span> : null}
            </span>
            <span className="bottom-nav__label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
